import { Check, RefreshCw } from "lucide-react";

export const CRM_ADDON_PRICE = 7699;
const OPTIONS = [
  { key: "hubspot", label: "HubSpot" },
  { key: "salesforce", label: "Salesforce" },
];

export function CrmAddonPicker({ value, onChange, dark = false }) {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((v) => v !== k) : [...value, k]);
  const box = dark ? "border-white/10 bg-white/5" : "border-black/10 bg-white";
  const muted = dark ? "text-white/60" : "text-ally-slate";
  return (
    <div data-testid="crm-addon-picker" className={`rounded-2xl border p-4 ${box}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-2.5">
          <RefreshCw size={18} className="text-ally-pink mt-0.5 shrink-0" />
          <div>
            <div className={`font-bold text-sm ${dark ? "text-white" : "text-ally-ink"}`}>Add-on: CRM integration</div>
            <div className={`text-xs mt-0.5 ${muted}`}>Two-way sync with HubSpot and/or Salesforce. One-time fee, same price for one or both. Your Elite membership continues at its regular price.</div>
          </div>
        </div>
        <div className={`text-sm font-black shrink-0 ${dark ? "text-white" : "text-ally-ink"}`}>+${CRM_ADDON_PRICE.toLocaleString("en-US")}</div>
      </div>
      <div className="flex gap-2 mt-3">
        {OPTIONS.map((o) => {
          const on = value.includes(o.key);
          return (
            <button key={o.key} type="button" data-testid={`crm-addon-${o.key}`} onClick={() => toggle(o.key)}
              className={`flex-1 flex items-center justify-center gap-2 rounded-xl border-2 px-3 py-2 text-sm font-bold transition-colors ${on ? "border-ally-pink bg-ally-pink/10 text-ally-pink" : dark ? "border-white/15 text-white/70 hover:border-white/30" : "border-black/10 text-ally-ink hover:border-black/25"}`}>
              <span className={`w-4 h-4 rounded border flex items-center justify-center ${on ? "bg-ally-pink border-ally-pink" : dark ? "border-white/40" : "border-black/30"}`}>
                {on && <Check size={11} className="text-white" />}
              </span>
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
